/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ topic: NonNullable<unknown>, question: NonNullable<unknown> }} Coach_Topic_PrefixInputs */

const en_us2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.topic}: ${i?.question}`)
};

const pt_br2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre ${i?.topic}: ${i?.question}`)
};

const es_419_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre ${i?.topic}: ${i?.question}`)
};

const pt_pt2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre ${i?.topic}: ${i?.question}`)
};

const fr_fr2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À propos de ${i?.topic} : ${i?.question}`)
};

const de_de2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu ${i?.topic}: ${i?.question}`)
};

const it_it2_coach_topic_prefix = /** @type {(inputs: Coach_Topic_PrefixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Su ${i?.topic}: ${i?.question}`)
};

/**
* | output |
* | --- |
* | "About {topic}: {question}" |
*
* @param {Coach_Topic_PrefixInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_topic_prefix = /** @type {((inputs: Coach_Topic_PrefixInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Topic_PrefixInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_topic_prefix(inputs)
	if (locale === "es-419") return es_419_coach_topic_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_topic_prefix(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_topic_prefix(inputs)
	if (locale === "de-DE") return de_de2_coach_topic_prefix(inputs)
	if (locale === "it-IT") return it_it2_coach_topic_prefix(inputs)
	return en_us2_coach_topic_prefix(inputs)
});
export { coach_topic_prefix as "coach.topic_prefix" }